module.exports = __webpack_public_path__ + "static/roboto-latin-900italic.822eba9c.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-900italic.eot
// module id = ./node_modules/typeface-roboto/files/roboto-latin-900italic.eot
// module chunks = 0